import React from "react";

// Styles //
import "./container-filter.scss";

interface ContainerFilterProps {
    title: string;
    children: any;
    active: boolean;
    className: string;
    onToggle: (index: number) => void;
}

const ContainerFilter = (props: ContainerFilterProps) => {
    const { title, children, active, className, onToggle } = props;

    return (
        <div
            className={`container-filter ${
                active ? "opened" : ""
            } ${className}`}
        >
            <div
                className={`container-filter__header ${active ? "opened" : ""}`}
                onClick={onToggle}
            >
                <h4>{title}</h4>
                <span className="icon-chevron-down1"></span>
            </div>
            <div
                className={`container-filter__content ${
                    active ? "opened" : ""
                }`}
            >
                <div className={`container-filter__content__inner`}>
                    {className === "region" && children[0] && 
                        <div className="container-filter__content__inner clarification">
                            <span>
                                Conoce perfiles ubicados sólo en Antioquia
                            </span>
                        </div>
                    }
                    {className === "typeVacancies" && children[0] && 
                        <div className="container-filter__content__inner clarification">
                            <span>
                                Explora oportunidades laborales en el extranjero. Por ahora, no podrás filtrar por ubicación.
                            </span>
                        </div>
                    }
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ContainerFilter;
